import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pb-6" }, "Time of day workflow should trigger", -1)

import { watch } from "vue"
import { ClockIcon } from "@heroicons/vue/outline"
import GgmsInput from "@/components/GgmsInput.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { dateTimeConverter } from "@/shared/utils/helpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeOfDayScheduleComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

watch(
    () => workflowStore.modelValue.time,
    () => {
        //convert time into ISO date
        if (workflowStore.modelValue.time) {
            workflowStore.modelValue.dateTime = dateTimeConverter(workflowStore.modelValue.time)
        }
        workflowStore.areButtonDisabled = !workflowStore.modelValue.time
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GgmsInput, {
      modelValue: _unref(workflowStore).modelValue.time,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
      label: "Time of day",
      type: "time",
      iconStart: _unref(ClockIcon)
    }, null, 8, ["modelValue", "iconStart"])
  ]))
}
}

})